<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Term">
          <a-input placeholder="Please enterTerm" v-decorator="[ 'duration', validatorRules.duration]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="MostBigAmount">
          <a-input placeholder="Please enterMostBigAmount" v-decorator="[ 'maxAmount', validatorRules.maxAmount]"/>
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="MostSmallAmount">
          <a-input placeholder="Please enterMostSmallAmount" v-decorator="[ 'minAmount', validatorRules.minAmount]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Disbursement Increment Amount">
          <a-input placeholder="Please enter disbursement increment amount" v-decorator="[ 'incrAmount', validatorRules.incrAmount]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Extension Quota">
          <a-input placeholder="Please enter extension quota" v-decorator="[ 'incrQuota', validatorRules.incrQuota]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Allow Extension Time">
          <dict-radio-group
              v-decorator="['allowDiferTime', validatorRules.allowDiferTime]"
              :dict-code="DICT_CODE.ALLOW_DIFER_TIME"
          />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Allow Pre-repayment">
            <a-switch checkedChildren="Allowed" unCheckedChildren="Not Allowed" v-decorator="[ 'allowPrepay', { initialValue: false, valuePropName: 'checked' }]"/>
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Service Fee Rate">
          <a-input placeholder="Please enter service fee rate" v-decorator="[ 'serviceFeeRate', validatorRules.serviceFeeRate]" :disabled="disabled"/>
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Extension Service Fee">
          <a-input placeholder="Please enter extension service fee" v-decorator="[ 'diferFeeRate', validatorRules.diferFeeRate]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Overdue Fee Rate">
          <a-input placeholder="Please enter overdue fee rate" v-decorator="[ 'overdueRate', validatorRules.overdueRate]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Daily Interest Rate">
          <a-input placeholder="Please enter daily interest rate" v-decorator="[ 'dayInterestRate', validatorRules.dayInterestRate]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Tax Fee Rate">
          <a-input placeholder="Please enter tax fee rate" v-decorator="[ 'ivaFee', validatorRules.ivaFee]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Status">
          <a-select
            v-decorator="[ 'status', validatorRules.status]"
          >
            <a-select-option :key="'0'">Invalid</a-select-option>
            <a-select-option :key="'1'">Valid</a-select-option>
          </a-select>
        </a-form-item>


      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addProductItem, editProductItem } from '@/webpublicapi/operation'
import DictRadioGroup from '../../modules/DictRadioGroup';
// duplicateCheck
export default {
  name: 'DictModal',
  components:{
    DictRadioGroup
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      allowPrepay:1,
      productId:'',
      visibleCheck: true,
      requiredCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        duration: { rules: [{ required: true, message: 'Please enterTerm!' }] },
        maxAmount: {
          rules: [{ required: true, message: 'Please enterMostBigAmount!' }]
        },
        minAmount: { rules: [{ required: true, message: 'Please enterMostSmallAmount!' }] },
        incrAmount: { rules: [{ required: true, message: 'Please enter disbursement increment amount!' }] },
        incrQuota: { rules: [{ required: true, message: 'Please enter extension quota!' }] },
        allowDiferTime: { rules: [{ required: true, message: 'Please enter allow extension time!' }] },
        // allowPrepay: { rules: [{ required: true, message: 'Please enter whether early repayment is allowed!' }] },
        serviceFeeRate: { rules: [{ required: this.requiredCheck, message: 'Please enter service fee rate!' }] },
        diferFeeRate: { rules: [{ required: true, message: 'Please enter extension service fee!' }] },
        dayInterestRate: { rules: [{ required: true, message: 'Please enter daily interest rate!' }] },
        overdueRate: { rules: [{ required: true, message: 'Please enter overdue fee rate!' }] },
        ivaFee: { rules: [{ required: false, message: 'Please enter tax fee rate!' }] },
        status: { rules: [{ required: true, message: 'Please select status!' }] }
      },
      disabled: false,
    }
  },
  created () {
    if(process.env.VUE_APP_CONFIG == "malaysia"){
      this.disabled = true
      this.requiredCheck = false
    }
  },
  methods: {
    add (proId,ssId) {
      this.productId = proId
      this.appSsid=ssId
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = (record.allowPrepay == 1)
      }
      this.visible = true;
      const data = pick(this.model, 'duration', 'maxAmount', 'minAmount','incrAmount','incrQuota','allowDiferTime', 'allowPrepay', 'serviceFeeRate','diferFeeRate','overdueRate','dayInterestRate','status', 'ivaFee');
      data.allowPrepay = !!data.allowPrepay;
      this.$nextTick(() => {
        this.form.setFieldsValue(data);
      })
    },
    onChose (checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0;
          let obj
          if (!that.model.id) {
            formData.productId = this.productId
            formData.appSsid=this.appSsid
            obj = addProductItem(formData)
          } else {
             obj = editProductItem(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
              that.close()
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
